export type SnipDataType = {
  deeplink: string;
  publicAccessKey: string;
  title: string;
  body: string;
  source: string;
  sources?: string[];
  sourceLabel: string;
  sourceThumbnail?: string;
  metadata?: Record<string, unknown>;
  thumbnailLocation?: string;
};

export const getSnipJSON = (snipData: SnipDataType) => {
  const {
    body,
    deeplink,
    publicAccessKey,
    title,
    source,
    sources,
    sourceLabel,
    metadata,
    thumbnailLocation,
  } = snipData;

  return JSON.stringify([
    {
      children: [{ text: '' }],
      type: 'needl-source',
      id: source,
      data: {
        source,
        sourceLabel,
        ...(sources ? { sources } : {}),
        ...(thumbnailLocation ? { thumbnailLocation } : {}),
      },
    },
    ...(title ? [{ children: [{ text: title }], type: 'h2' }] : []),
    ...(metadata
      ? Object.keys(metadata).reduce((acc, dataKey) => {
          if (!metadata[dataKey]) return acc;
          return [
            ...acc,
            {
              children: [{ text: `${dataKey}: ${metadata[dataKey]}` }],
              type: 'p',
            },
          ];
        }, [] as { type: string; children: { text: string }[] }[])
      : []),
    ...(body
      ? [
          {
            children: [
              { text: body.length > 1000 ? `${body.slice(0, 1000)}...` : body },
            ],
            type: 'p',
          },
        ]
      : []),
    {
      children: [{ text: '' }],
      type: 'needl-link',
      id: deeplink,
      data: {
        deeplink,
        source,
        ...(publicAccessKey ? { publicAccessKey } : {}),
      },
    },
    { children: [{ text: '' }], type: 'p' }, // a empty paragraph node for users to quickly start taking notes
  ]);
};
